import React, { useState } from "react";
import { Clock, TrendUp, Quotes, Play } from "@phosphor-icons/react";

export const SuccessStoryCard = ({ s, i }) => {
  const [playing, setPlaying] = useState(false);
  return (
    <article className="card-matte p-7 md:p-9 relative overflow-hidden" data-testid={`story-card-${i}`}>
      {s.placeholder && (
        <span className="absolute top-4 right-4 text-[9px] font-bold rounded-full bg-amber-500/15 text-amber-300 border border-amber-500/25 px-2.5 py-1" data-testid={`story-sample-badge-${i}`}>SAMPLE STORY</span>
      )}
      <div className="flex items-center gap-3 mb-5">
        {s.logo_url
          ? <img src={s.logo_url} alt={s.business} className="h-11 w-11 rounded-xl object-cover border border-white/10" loading="lazy" />
          : <div className="h-11 w-11 rounded-xl bg-[#6B3DFF]/15 border border-[#6B3DFF]/25 flex items-center justify-center font-head font-bold brand-text">{(s.business || "?").slice(0, 1)}</div>}
        <div>
          <h3 className="font-head font-bold text-lg md:text-xl leading-tight">{s.business}</h3>
          <div className="text-xs text-[#7a7a7a]">{s.industry}</div>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <div className="label-caps mb-1.5 text-red-300/70">The problem</div>
          <p className="text-sm text-[#9a9a9a] leading-relaxed">{s.problem}</p>
          <div className="label-caps mt-4 mb-1.5 brand-text">The Vozelto solution</div>
          <p className="text-sm text-[#cfcfcf] leading-relaxed">{s.solution}</p>
        </div>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div className="rounded-xl border border-white/8 bg-white/[0.03] p-4">
              <Clock size={18} className="brand-text mb-1.5" weight="duotone" />
              <div className="font-head font-extrabold text-lg leading-tight" data-testid={`story-time-saved-${i}`}>{s.time_saved || "—"}</div>
              <div className="text-[10px] text-[#7a7a7a]">time saved</div>
            </div>
            <div className="rounded-xl border border-white/8 bg-white/[0.03] p-4">
              <TrendUp size={18} className="text-emerald-400 mb-1.5" weight="duotone" />
              <div className="font-head font-extrabold text-lg leading-tight" data-testid={`story-revenue-${i}`}>{s.revenue_increase || "—"}</div>
              <div className="text-[10px] text-[#7a7a7a]">business impact</div>
            </div>
          </div>
          {s.image_url && (
            <img src={s.image_url} alt={`${s.business} results`} className="rounded-xl border border-white/8 w-full" loading="lazy" data-testid={`story-image-${i}`} />
          )}
          {s.video_url && (
            playing
              ? <video src={s.video_url} controls autoPlay className="rounded-xl border border-white/8 w-full" data-testid={`story-video-${i}`} />
              : <button onClick={() => setPlaying(true)} data-testid={`story-video-play-${i}`}
                  className="w-full rounded-xl border border-white/8 bg-white/[0.03] py-6 flex items-center justify-center gap-2 text-sm text-[#cfcfcf] hover:border-[#6B3DFF]/40 transition-colors">
                  <span className="h-9 w-9 rounded-full bg-[#6B3DFF] flex items-center justify-center"><Play size={15} className="text-white ml-0.5" weight="fill" /></span>
                  Watch their story
                </button>
          )}
          {s.quote && (
            <blockquote className="rounded-xl border border-[#6B3DFF]/20 bg-[#6B3DFF]/[0.05] p-4">
              <Quotes size={18} className="brand-text mb-1.5" weight="fill" />
              <p className="text-sm text-[#e6e6e6] italic leading-relaxed">“{s.quote}”</p>
              {s.person_name && <footer className="mt-2 text-xs text-[#9a9a9a]">— {s.person_name}{s.person_role ? `, ${s.person_role}` : ""}</footer>}
            </blockquote>
          )}
        </div>
      </div>
    </article>
  );
};
